import { createIcon } from "../create-icon"

export const ErrorCircleIcon = createIcon({
  title: "ErrorCircleIcon",
  viewBox: "0 0 12 12",
  d: "M12 6A6 6 0 1 0 0 6a6 6 0 0 0 12 0zM4.146 4.146a.5.5 0 0 1 .708 0L6 5.293l1.146-1.147a.5.5 0 1 1 .708.708L6.707 6l1.147 1.146a.5.5 0 1 1-.708.708L6 6.707 4.854 7.854a.5.5 0 1 1-.708-.708L5.293 6 4.146 4.854a.5.5 0 0 1 0-.708z",
})

ErrorCircleIcon.displayName = "ErrorCircleIcon"
